var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PVTabs',_vm._b({ref:"tabs",staticClass:"cn-tabs-new",class:{
    'is-begin': _setup.isBegin,
    'is-end': _setup.isEnd,
  },attrs:{"scrollable":_setup.isScrollable},on:{"tab-click":function($event){return _vm.$emit('tab-click', $event)}}},'PVTabs',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }